import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';

@Component
export default class EpicHeaderThreeSmall extends Vue {
    public title: string = 'EpicHeaderThreeSmall';
    public configs = new CommonConfig();
    public avatarUri = `${this.configs.rifoDesignAssetsUrl}/rifo_logo.png`;

    @Prop({ default: null })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
